import { webClient } from "@shared/apis"
import { PaymentInformation, Role } from "@shared/contexts"

const popup = {
  random: async (getRequest: GetRequest) =>
    webClient.get<Popup>(`/popups/random`, {
      params: getRequest,
    }),
  addClickCount: (id: number) => webClient.post(`/popups/${id}`),
}

export default popup

export interface Popup {
  id: number
  userId: number
  nickname: string
  popupName: string
  imageUrl: string
  link: string
  exposedTarget: string
  exposedStartDate: string
  exposedEndDate: string
  weight: number
  clickCount: number
  exposedDays: string
  isEnabled: boolean
  createdAt: string
  updatedAt: string
  isClosed: boolean
  contents: string
  contentsType: PopupContentsType
}

export type PopupContentsType = "TEXT" | "IMAGE"

interface GetRequest {
  exposedTarget: PaymentInformation
  targetPlayer: "VOD" | "LIVE"
  userId: number
  viewerRole: Role
}
